import React from 'react';

import { Box, Paper, Typography } from '@mui/material';

interface Props {
  label: string;
  children: React.ReactNode;
}

export default function ValuePanel({ label, children }: Props) {
  return (
    <Paper variant="outlined" sx={{ p: 1.25, flex: 1, minWidth: 220, bgcolor: 'grey.50' }}>
      <Typography variant="caption" color="text.secondary" fontWeight={700}>
        {label}
      </Typography>
      <Box sx={{ mt: 0.75 }}>{children}</Box>
    </Paper>
  );
}
